export const POST_RETAILER_DATA_API = 'POST_RETAILER_DATA_API'
export const POST_RETAILER_DATA_API_SUCCESS = 'POST_RETAILER_DATA_API_SUCCESS'

export const RETAILER_DATA_API_ERROR_ACTION = 'RETAILER_DATA_API_ERROR_ACTION'


